import saveWin32Style from "./mutators/saveWin32Style";
import { getWin32StyleEnabledFromPrimeSettings, setWin32StylingEnabledGetter, } from "owa-theme-common";
import isWin32StylingEnabled from "./selectors/isWin32StylingEnabled";

/**
 * Seeds the Win32 style enabled flag from the primed boot setting.
 *
 * Called once at boot. After this the local store is the single source of truth
 * for the session, so an in-session Save is never overwritten by the boot source.
 */
export default function initializeWin32StyleStore(): void {
    saveWin32Style(getWin32StyleEnabledFromPrimeSettings());
    setWin32StylingEnabledGetter(isWin32StylingEnabled);
}
